export default defineNuxtRouteMiddleware(() => {
  const profile = useProfileStore();
  if (!profile.featureFlags.dailyQuiz) {
    return navigateTo('/', { redirectCode: 301 });
  }
});
